import React, { useCallback, useEffect, useState } from 'react';

import { BackButton } from '../../common/button/back-button/BackButton';

import { StudyTrialCreateGeneralTab } from './general/StudyTrialCreateGeneralTab';
import { StudyTrialsSitesTab } from './sites/StudyTrialsSitesTab';
import { StudyTrialsStaffTab } from './staff/StudyTrialsStaffTab';
import { StudyScheduleTab } from './visit-schedules/StudyScheduleTab';

import './StudyTrialCreate.css';

export const StudyTrialCreate = ({ context, setContext, navigateTo, showToaster, setSpinnerText, toolTipsEnabled }) => {
  const [showSitesTab, setShowSitesTab] = useState(false);
  const [showStaffTab, setShowStaffTab] = useState(false);
  const [showSchedulesTab, setShowSchedulesTab] = useState(false);

  const [activeTab, setActiveTab] = useState('studyTrialCreateGeneral');
  const [study, setStudy] = useState({});
  const [sitesFromBreadcrumbs, setSitesFromBreadcrumbs] = useState([]);
  const [visits, setVisits] = useState([]);
  const [currentScreen, setCurrentScreen] = useState('studyTrialCreateGeneral');

  const setStudyFromBreadcrumbs = useCallback(() => {
    if (context.breadcrumbs.newStudyGeneralBreadcrumb !== undefined) {
      setStudy(context.breadcrumbs.newStudyGeneralBreadcrumb.data);
    }

    if (context.breadcrumbs.newStudySitesBreadcrumb !== undefined) {
      setSitesFromBreadcrumbs(context.breadcrumbs.newStudySitesBreadcrumb.data);
    }
  }, [context.breadcrumbs]);

  useEffect(() => {
    setStudyFromBreadcrumbs();
  }, [setStudyFromBreadcrumbs]);

  const handleSaveClick = (link) => {
    setCurrentScreen(link);
  };

  const screenMap = new Map();
  screenMap.set(
    'studyTrialCreateGeneral',
    <StudyTrialCreateGeneralTab
      context={context}
      setContext={setContext}
      study={study}
      navigateTo={navigateTo}
      setCurrentScreen={setCurrentScreen}
      toolTipsEnabled={toolTipsEnabled}
      setSpinnerText={setSpinnerText}
      showToaster={showToaster}
      handleSaveClick={handleSaveClick}
      setShowSchedulesTab={setShowSchedulesTab}
    />
  );
  screenMap.set(
    'studySchedules',
    <StudyScheduleTab
      context={context}
      setContext={setContext}
      navigateTo={navigateTo}
      activeTab="studySchedules"
      setActiveTab={setActiveTab}
      handleSaveClick={handleSaveClick}
      setSpinnerText={setSpinnerText}
      showToaster={showToaster}
      visits={visits}
      setVisits={setVisits}
      setCurrentScreen={setCurrentScreen}
      study={study}
      editMode={false}
      setShowSitesTab={setShowSitesTab}
    />
  );
  screenMap.set(
    'studyTrialSites',
    <StudyTrialsSitesTab
      context={context}
      sitesFromBreadcrumbs={sitesFromBreadcrumbs}
      setContext={setContext}
      navigateTo={navigateTo}
      activeTab={'studyTrialSites'}
      setActiveTab={setActiveTab}
      setShowStaffTab={setShowStaffTab}
      handleSaveClick={handleSaveClick}
      setSpinnerText={setSpinnerText}
      showToaster={showToaster}
      toolTipsEnabled={toolTipsEnabled}
    />
  );
  screenMap.set(
    'studyTrialStaff',
    <StudyTrialsStaffTab
      context={context}
      setContext={setContext}
      navigateTo={navigateTo}
      activeTab="studyTrialStaff"
      setActiveTab={setActiveTab}
      setShowSchedulesTab={setShowSchedulesTab}
      handleSaveClick={handleSaveClick}
      setSpinnerText={setSpinnerText}
      showToaster={showToaster}
    />
  );

  const handleBack = () => {
    navigateTo('studyTrialAdmin');
  };

  const handleNavigationClick = (tab) => {
    setActiveTab(tab);
    setCurrentScreen(tab);
  };

  return (
    <div className="study-trial-create-container">
      <div className="study-trial-create-header-container">
        <BackButton onClick={handleBack} />
        <h2>Create New Study / Clinical Trial Registration</h2>
      </div>

      <div className="wizard-content-container">
        <div className="wizard-main-content-container">
          <div className="clients-create-container">
            <div className="clients-create-tab-container">
              <div
                className={
                  'study-trial-create-tab general ' + (activeTab === 'studyTrialCreateGeneral' ? 'active-tab' : null)
                }
                onClick={() => handleNavigationClick('studyTrialCreateGeneral')}
              >
                General
              </div>
              {showSchedulesTab && (
                <div
                  className={
                    'study-trial-create-tab schedules ' + (activeTab === 'studySchedules' ? 'active-tab' : null)
                  }
                  onClick={() => handleNavigationClick('studySchedules')}
                >
                  Visit Schedules
                </div>
              )}
              {showSitesTab && (
                <div
                  className={'study-trial-create-tab sites ' + (activeTab === 'studyTrialSites' ? 'active-tab' : null)}
                  onClick={() => handleNavigationClick('studyTrialSites')}
                >
                  Sites
                </div>
              )}
              {showStaffTab && (
                <div
                  className={'study-trial-create-tab staff ' + (activeTab === 'studyTrialStaff' ? 'active-tab' : null)}
                  onClick={() => handleNavigationClick('studyTrialStaff')}
                >
                  Staff
                </div>
              )}
            </div>
            <div className={'study-trial-create-tab-content ' + activeTab}>{screenMap.get(currentScreen)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
